var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "separation-element-settings" } }, [
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label", attrs: { for: "line-color" } }, [
        _vm._v("Çizgi Rengi"),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.separationElement.separationColor,
            expression: "item.separationElement.separationColor",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "color", id: "line-color" },
        domProps: { value: _vm.item.separationElement.separationColor },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.item.separationElement,
                "separationColor",
                $event.target.value
              )
            },
            function ($event) {
              return _vm.setSeparationColor(
                _vm.item.separationElement.separationColor
              )
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("Ayırma elemanının rengini seçin veya girin (örn. #RRGGBB)"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "element-height" } },
        [_vm._v("Ayırma Elemanı Yüksekliği")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.separationElement.separatorHeight,
            expression: "item.separationElement.separatorHeight",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "number", id: "element-height" },
        domProps: { value: _vm.item.separationElement.separatorHeight },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.item.separationElement,
                "separatorHeight",
                $event.target.value
              )
            },
            function ($event) {
              return _vm.setSeparatorHeight(
                _vm.item.separationElement.separatorHeight
              )
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("Ayırma elemanının yüksekliğini girin"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "bottom-margin" } },
        [_vm._v("Altındaki Boşluk")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.separationElement.separatorBottom,
            expression: "item.separationElement.separatorBottom",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "number", id: "bottom-margin" },
        domProps: { value: _vm.item.separationElement.separatorBottom },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.item.separationElement,
                "separatorBottom",
                $event.target.value
              )
            },
            function ($event) {
              return _vm.setSeparatorBottom(
                _vm.item.separationElement.separatorBottom
              )
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("Ayırma elemanının altına boşluk ekleyin"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label", attrs: { for: "top-margin" } }, [
        _vm._v("Üstündeki Boşluk"),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.separationElement.separatorTop,
            expression: "item.separationElement.separatorTop",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "number", id: "top-margin" },
        domProps: { value: _vm.item.separationElement.separatorTop },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.item.separationElement,
                "separatorTop",
                $event.target.value
              )
            },
            function ($event) {
              return _vm.setSeparatorTop(
                _vm.item.separationElement.separatorTop
              )
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("Ayırma elemanının üstüne boşluk ekleyin"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "side-margin" } },
        [_vm._v("Yan Boşluk")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.separationElement.separatorSide,
            expression: "item.separationElement.separatorSide",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "number", id: "side-margin" },
        domProps: { value: _vm.item.separationElement.separatorSide },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.item.separationElement,
                "separatorSide",
                $event.target.value
              )
            },
            function ($event) {
              return _vm.setSeparatorSide(
                _vm.item.separationElement.separatorSide
              )
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("Ayırma elemanının sağına ve soluna boşluk ekleyin"),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }